module.exports = __webpack_public_path__ + "img/trade.1b4c4945.png";